import React from "react";
import { Button } from "reactstrap";

import {
  AUTOPILOT_COLORS,
  autopilotSecondaryButtonStyle,
} from "../../../../components/autopilot/styles";
import SectionCard from "../../../../components/SectionCard";
import StatusBadge from "./StatusBadge";

// Estado pós-envio (PO1-2717): semântica de FILA, nunca de processamento
// imediato. Os arquivos saem daqui como "Na fila"; o desfecho aparece no card
// "Últimos envios" depois que a esteira roda.
export default function ResultadoEnvio({ resultado, onNovoEnvio }) {
  const arquivos = resultado?.arquivos || [];

  return (
    <SectionCard>
      <div
        style={{
          color: AUTOPILOT_COLORS.statusSuccess,
          fontWeight: 700,
          fontSize: "0.86rem",
          marginBottom: 10,
        }}
      >
        {arquivos.length === 1
          ? "1 arquivo entregue"
          : `${arquivos.length} arquivos entregues`}{" "}
        na fila de processamento
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {arquivos.map((arquivo) => (
          <div
            key={arquivo.nome}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 8,
            }}
          >
            <span style={{ color: AUTOPILOT_COLORS.text, fontSize: "0.82rem" }}>
              {arquivo.nome}
            </span>
            <StatusBadge status={arquivo.status} />
          </div>
        ))}
      </div>
      <p
        style={{
          color: AUTOPILOT_COLORS.muted,
          fontSize: "0.76rem",
          margin: "10px 0 0",
        }}
      >
        Arquivo com nome já existente na origem é recusado pela esteira; o motivo
        aparece em "Últimos envios".
      </p>
      <Button
        size="sm"
        style={{ ...autopilotSecondaryButtonStyle, marginTop: 14 }}
        onClick={onNovoEnvio}
      >
        Novo envio
      </Button>
    </SectionCard>
  );
}
